module.exports = __webpack_public_path__ + "media/img/Scholarships2u-Logo-favicon-5ca325913c9939d15f01e9345f175e8f.png";